module.exports = __webpack_public_path__ + "static/media/jacques.f68d6dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PublicWebsite/SocialProof/jacques.png
// module id = 523
// module chunks = 0